
import React from "react";
import { useStrategiesTable } from "./StrategiesTableProvider";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteStrategyDialogProps {
  onDeleteStrategy: (id: string) => Promise<void>;
}

const DeleteStrategyDialog = ({ onDeleteStrategy }: DeleteStrategyDialogProps) => {
  const { deletingStrategyId, setDeletingStrategyId } = useStrategiesTable();
  const deleteDialogDescriptionId = "delete-strategy-dialog-description";

  const handleDialogChange = (open: boolean) => {
    if (!open) {
      setDeletingStrategyId(null);
    }
  };

  const handleConfirmDelete = async () => {
    if (deletingStrategyId) {
      try {
        await onDeleteStrategy(deletingStrategyId);
      } finally {
        setDeletingStrategyId(null);
      }
    }
  };

  return (
    <AlertDialog open={!!deletingStrategyId} onOpenChange={handleDialogChange}>
      <AlertDialogContent aria-describedby={deleteDialogDescriptionId}>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Strategy</AlertDialogTitle>
          <AlertDialogDescription id={deleteDialogDescriptionId}>
            Are you sure you want to delete this strategy? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirmDelete}>Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteStrategyDialog;
